const CACHE_PREFIX = 'vortex_cache_';
const DEFAULT_TTL = 7 * 24 * 60 * 60 * 1000;

export function buildCacheKey(parts) {
  const key = Array.isArray(parts) ? parts.join('__') : String(parts);
  return CACHE_PREFIX + key;
}

export function getCachedData(key, ttl = DEFAULT_TTL) {
  try {
    const fullKey = key.startsWith(CACHE_PREFIX) ? key : buildCacheKey(key);
    const raw = localStorage.getItem(fullKey);
    if (!raw) return null;
    const entry = JSON.parse(raw);
    if (Date.now() - entry.timestamp > ttl) {
      localStorage.removeItem(fullKey);
      return null;
    }
    return entry.data;
  } catch {
    return null;
  }
}

export function getCachedDataWithVersion(key, ttl = DEFAULT_TTL) {
  try {
    const fullKey = key.startsWith(CACHE_PREFIX) ? key : buildCacheKey(key);
    const raw = localStorage.getItem(fullKey);
    if (!raw) return null;
    const entry = JSON.parse(raw);
    if (Date.now() - entry.timestamp > ttl) {
      localStorage.removeItem(fullKey);
      return null;
    }
    return entry;
  } catch {
    return null;
  }
}

export function setCachedData(key, data, version = null) {
  try {
    const fullKey = key.startsWith(CACHE_PREFIX) ? key : buildCacheKey(key);
    const payload = { data, version: version || null, timestamp: Date.now() };
    localStorage.setItem(fullKey, JSON.stringify(payload));
  } catch (e) {
    if (e.name === 'QuotaExceededError') {
      purgePrefix(CACHE_PREFIX);
      try {
        const fullKey = key.startsWith(CACHE_PREFIX) ? key : buildCacheKey(key);
        localStorage.setItem(fullKey, JSON.stringify({ data, version: version || null, timestamp: Date.now() }));
      } catch {}
    }
  }
}

export function removeCachedData(key) {
  try {
    const fullKey = key.startsWith(CACHE_PREFIX) ? key : buildCacheKey(key);
    localStorage.removeItem(fullKey);
  } catch {}
}

function purgePrefix(prefix) {
  try {
    Object.keys(localStorage)
      .filter(k => k.startsWith(prefix))
      .forEach(k => localStorage.removeItem(k));
  } catch {}
}

export function isCacheValid(entry, ttl = DEFAULT_TTL) {
  if (!entry || !entry.timestamp) return false;
  return Date.now() - entry.timestamp <= ttl;
}
